import React from 'react';
import type { FC } from 'react';
import type { UserInfo } from '@wix/cli-auth';
import { Text } from '@wix/cli-ui-kit';

interface Props {
  userInfo: UserInfo;
}

export const WhoamiCommand: FC<Props> = ({ userInfo }) => {
  return (
    <Text>
      Logged in as{' '}
      <Text skin="warning" bold>
        {userInfo.email}
      </Text>
    </Text>
  );
};
